import CryptoJS from "crypto-js";

/**
 * 羊城派API签名工具类
 * 严格按照API文档要求实现签名算法
 */
class YCPSignature {
  constructor() {
    // 配置信息
    this.config = {
      appKey: "zk8wtGUHoIQktKsZ",
      appSecret: "uM94Nnt14k20GztnBANK4ZD1PxFxZUPt",
      requestSource: "H5",
    };

    // 生成设备ID
    this.deviceId = this.generateDeviceId();
  }

  /**
   * 生成设备ID
   */
  generateDeviceId() {
    let deviceId = localStorage.getItem("ycp_device_id");
    if (!deviceId) {
      deviceId =
        "web_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
      localStorage.setItem("ycp_device_id", deviceId);
    }
    return deviceId;
  }

  /**
   * URL编码参数值（严格按API要求）
   */
  urlEncodeValue(value) {
    return encodeURIComponent(value);
  }

  /**
   * 构建完整URL（包含查询参数）
   */
  buildFullUrl(baseURL, path, params = {}) {
    // 构建基本URL
    let fullUrl = baseURL + path;

    // 处理查询参数
    if (params && Object.keys(params).length > 0) {
      const queryParams = [];

      Object.keys(params).forEach((key) => {
        if (params[key] !== undefined && params[key] !== null) {
          // 对参数值进行URL编码
          const encodedValue = this.urlEncodeValue(params[key]);
          queryParams.push(`${key}=${encodedValue}`);
        }
      });

      if (queryParams.length > 0) {
        fullUrl += (fullUrl.includes("?") ? "&" : "?") + queryParams.join("&");
      }
    }

    return fullUrl;
  }

  /**
   * 计算请求体MD5（Base64格式）
   */
  calculateBodyMD5(data) {
    if (!data) {
      // 空字符串的MD5 Base64值
      return "1B2M2Y8AsgTpgAmY7PhCfg==";
    }

    let dataString;
    if (typeof data === "string") {
      dataString = data;
    } else if (data instanceof FormData) {
      // FormData类型，无法直接计算MD5，按空字符串处理
      return "1B2M2Y8AsgTpgAmY7PhCfg==";
    } else {
      // JSON对象
      dataString = JSON.stringify(data);
    }

    // 计算MD5
    const md5Hash = CryptoJS.MD5(dataString);
    // 转换为Base64
    return CryptoJS.enc.Base64.stringify(md5Hash);
  }

  /**
   * 生成GET请求签名
   * @param {string} method - HTTP方法
   * @param {string} url - 完整URL
   * @param {number} timestamp - 时间戳（毫秒）
   * @returns {string} 签名
   */
  generateGetSignature(method, url, timestamp) {
    // 构建待签名字符串
    const stringToSign = `${method.toUpperCase()}\n${url}\n${timestamp}\n`;

    // console.log("GET待签名字符串:", stringToSign);
    // console.log("原始字符串:", JSON.stringify(stringToSign));

    // HMAC-SHA256加密
    const hmac = CryptoJS.HmacSHA256(stringToSign, this.config.appSecret);
    // Base64编码
    return CryptoJS.enc.Base64.stringify(hmac);
  }

  /**
   * 生成POST请求签名
   * @param {string} method - HTTP方法
   * @param {string} url - 完整URL
   * @param {number} timestamp - 时间戳（毫秒）
   * @param {object|string} data - 请求体数据
   * @returns {string} 签名
   */
  generatePostSignature(method, url, timestamp, data) {
    // 计算请求体MD5
    const contentMD5 = this.calculateBodyMD5(data);

    // 构建待签名字符串
    const stringToSign = `${method.toUpperCase()}\n${url}\n${timestamp}\n${contentMD5}`;

    // console.log("POST待签名字符串:", stringToSign);
    // console.log("原始字符串:", JSON.stringify(stringToSign));
    // console.log("请求体MD5:", contentMD5);

    // HMAC-SHA256加密
    const hmac = CryptoJS.HmacSHA256(stringToSign, this.config.appSecret);
    // Base64编码
    return CryptoJS.enc.Base64.stringify(hmac);
  }

  /**
   * 生成请求头
   * @param {object} config - axios配置
   * @returns {object} 请求头对象
   */
  generateHeaders(config) {
    const { method, baseURL, url, data, params } = config;
    const timestamp = Date.now();

    // 构建完整URL（用于签名）
    const fullUrl = this.buildFullUrl(baseURL, url, params);

    let signature;
    if (method.toUpperCase() === "GET") {
      // GET请求签名
      signature = this.generateGetSignature(method, fullUrl, timestamp);
    } else {
      // POST/PUT/DELETE请求签名
      signature = this.generatePostSignature(method, fullUrl, timestamp, data);
    }

    // 返回请求头
    return {
      "X-YCWB-Ca-Key": this.config.appKey,
      "X-YCWB-Ca-Timestamp": timestamp.toString(),
      "X-YCWB-Ca-Signature": signature,
      "X-YCWB-DEVICE-ID": this.deviceId,
      "X-YCWB-REQUEST-SOURCE": this.config.requestSource,
    };
  }

  /**
   * 生成测试签名（用于调试）
   */
  testSignature(method, url, timestamp, data = null) {
    let signature;
    if (method.toUpperCase() === "GET") {
      signature = this.generateGetSignature(method, url, timestamp);
    } else {
      signature = this.generatePostSignature(method, url, timestamp, data);
    }

    return {
      signature,
      headers: {
        "X-YCWB-Ca-Key": this.config.appKey,
        "X-YCWB-Ca-Timestamp": timestamp.toString(),
        "X-YCWB-Ca-Signature": signature,
        "X-YCWB-DEVICE-ID": this.deviceId,
        "X-YCWB-REQUEST-SOURCE": this.config.requestSource,
      },
    };
  }
}

// 创建单例
const ycpSignature = new YCPSignature();
export default ycpSignature;
